// Helpers d'estimation de poids pour images stockées (URL ou base64).

export function imageSizeKB(value) {
  if (!value || typeof value !== "string") return 0;
  if (value.startsWith("data:")) {
    // base64: longueur de la partie données * 3/4
    const idx = value.indexOf(",");
    const data = idx >= 0 ? value.slice(idx + 1) : value;
    return Math.round((data.length * 3) / 4 / 1024);
  }
  return null; // URL externe -> on ne connaît pas le poids sans HEAD
}

export function describeImage(value) {
  if (!value) return { label: "Aucune image", kb: 0, kind: "none" };
  if (value.startsWith("data:")) {
    const kb = imageSizeKB(value);
    return { label: `Stockée en base : ${kb} Ko`, kb, kind: "base64" };
  }
  return { label: "URL externe", kb: null, kind: "url" };
}
